// DEPARTMENTS used to be hard-coded here. It drifted out of sync with the `departments`
// table (it listed Drawing/Design/Accounts/HR-Admin while the table holds Designing/
// Drafting/Site Visit), so the hiring form now loads departments from `/api/departments`.

// JOB_TYPES and WORK_TYPES were hard-coded here too. V7 moved them into the
// `employment_types` and `work_arrangements` tables, so the hiring form reads them from
// /api/employment-types and /api/work-arrangements and HR can edit the options.

// QUALIFICATION_PREFERENCES was hard-coded here too, and the tools combo box had no
// option list at all. V8 moved both into the `qualifications` and `tools` tables, so the
// hiring form reads them from /api/qualifications and /api/tools and HR can edit the
// options from Reference Data.

export const GENDER_PREFERENCES = Object.freeze(['Any', 'Male', 'Female', 'Other']);

export const POSITION_COUNTS = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
